import { call, put, takeLatest, all } from "redux-saga/effects";
import EgresosActions, {
  Types as EgresosTypes,
} from "../../stores/hospitalizacion/egresos/Actions";
import EgresosService from "../../services/egresos/EgresosService";
import ResponseCode from "../../services/ResponseCode";

const isOkCode = (codigo) => codigo === 0 || codigo === ResponseCode.OK.code;

function* consultarIngresosPss({ payload }) {
  const { Compania, Reclamante, Ramo, Secuencial, Ano } = payload;

  yield put(EgresosActions.consultarIngresosPssLoading());
  yield put(EgresosActions.limpiarCoberturasCierreCuenta());

  try {
    const response = yield call(EgresosService.consultarIngresosPss, {
      Compania,
      Reclamante,
      Ramo,
      Secuencial,
      Ano,
    });

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.consultarIngresosPssFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.consultarIngresosPssFailure(response.respuesta)
      );
      return;
    }
    yield put(
      EgresosActions.consultarIngresosPssSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.consultarIngresosPssFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error inesperado al consultar ingresos.",
      })
    );
  }
}

function* consultarCoberturasCierreCuenta({ payload }) {
  yield put(EgresosActions.consultarCoberturasCierreCuentaLoading());

  try {
    const respCob = yield call(
      EgresosService.consultarCoberturasCierreCuenta,
      {
        Compania: payload.Compania,
        Reclamante: payload.Reclamante,
        Servicio: payload.Servicio,
        TipoReclamante: payload.TipoReclamante,
        Plan: payload.Plan,
        tamanoPagina: payload.tamanoPagina,
        numeroPagina: payload.numeroPagina,
        cobertura: payload.cobertura,
      }
    );

    if (
      !respCob?.respuesta ||
      respCob.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.consultarCoberturasCierreCuentaFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codCob = respCob.respuesta.codigo;

    // Si el código es 204 (No Content), tratarlo como éxito sin datos (no mostrar error)
    // Devolver estructura con array vacío para que el popup se abra pero muestre "no hay datos"
    if (codCob === 204) {
      yield put(
        EgresosActions.consultarCoberturasCierreCuentaSuccess({
          coberturasCierresCuentas: [],
        })
      );
      return;
    }

    if (!isOkCode(codCob)) {
      yield put(
        EgresosActions.consultarCoberturasCierreCuentaFailure(
          respCob.respuesta
        )
      );
      return;
    }

    yield put(
      EgresosActions.consultarCoberturasCierreCuentaSuccess(
        respCob.data
      )
    );
  } catch (errorCob) {
    yield put(
      EgresosActions.consultarCoberturasCierreCuentaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          errorCob?.message ||
          "Error inesperado al consultar coberturas de cierre de cuenta.",
      })
    );
  }
}

function* eliminarCobertura({ payload }) {
  yield put(EgresosActions.eliminarCoberturaLoading());

  try {
    const response = yield call(EgresosService.eliminarCobertura, {
      ano: Number(payload.ano),
      compania: Number(payload.compania),
      ramo: Number(payload.ramo),
      secuencial: Number(payload.secuencial),
      cobertura: Number(payload.cobertura),
    });

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.eliminarCoberturaFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.eliminarCoberturaFailure(response.respuesta)
      );
      return;
    }

    yield put(EgresosActions.eliminarCoberturaSuccess(response.data));
    yield put(EgresosActions.eliminarCoberturaDeIngresoDetalle(payload.cobertura));
  } catch (error) {
    yield put(
      EgresosActions.eliminarCoberturaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error inesperado al eliminar cobertura.",
      })
    );
  }
}

function* buscarCuentasCerradas({ payload }) {
  yield put(EgresosActions.buscarCuentasCerradasLoading());

  try {
    const response = yield call(
      EgresosService.buscarCuentasCerradas,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.buscarCuentasCerradasFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.buscarCuentasCerradasFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.buscarCuentasCerradasSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.buscarCuentasCerradasFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al buscar cuentas cerradas.",
      })
    );
  }
}

function* validarCobertura({ payload }) {
  yield put(EgresosActions.validarCoberturaLoading());

  try {
    const response = yield call(
      EgresosService.validarCobertura,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.validarCoberturaFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.validarCoberturaFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.validarCoberturaSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.validarCoberturaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al validar cobertura.",
      })
    );
  }
}

function* validarServicioAmbulatorio({ payload }) {
  yield put(EgresosActions.validarServicioAmbulatorioLoading());

  try {
    const response = yield call(
      EgresosService.validarServicioAmbulatorio,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.validarServicioAmbulatorioFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.validarServicioAmbulatorioFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.validarServicioAmbulatorioSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.validarServicioAmbulatorioFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al validar servicio ambulatorio.",
      })
    );
  }
}

function* consultarTipoPssNoMedico({ payload }) {
  const codigoPss = payload?.CodigoPss || payload?.codigoPss;
  
  if (!codigoPss || Number(codigoPss) === 0) {
    yield put(
      EgresosActions.consultarTipoPssNoMedicoEgresoFailure({
        codigo: ResponseCode.BAD_REQUEST?.code || "400",
        mensaje: "Código PSS no válido",
      })
    );
    return;
  }

  yield put(EgresosActions.consultarTipoPssNoMedicoEgresoLoading());

  try {
    const response = yield call(
      EgresosService.consultarTipoPssNoMedico,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.consultarTipoPssNoMedicoEgresoFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.consultarTipoPssNoMedicoEgresoFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.consultarTipoPssNoMedicoEgresoSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.consultarTipoPssNoMedicoEgresoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al consultar tipo PSS no médico.",
      })
    );
  }
}

function* validarAfiliadoVigente({ payload }) {
  yield put(EgresosActions.validarAfiliadoVigenteLoading());

  try {
    const response = yield call(
      EgresosService.validarAfiliadoVigente,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.validarAfiliadoVigenteFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.validarAfiliadoVigenteFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.validarAfiliadoVigenteSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.validarAfiliadoVigenteFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al validar afiliado vigente.",
      })
    );
  }
}

function* guardarEgreso({ payload }) {
  yield put(EgresosActions.guardarEgresoLoading());

  try {
    const response = yield call(
      EgresosService.guardarEgreso,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.guardarEgresoFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.guardarEgresoFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.guardarEgresoSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.guardarEgresoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al guardar egreso.",
      })
    );
  }
}

function* consultarReclamantes({ payload }) {
  yield put(EgresosActions.consultarReclamantesLoading());

  try {
    const response = yield call(
      EgresosService.consultarReclamantes,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.consultarReclamantesFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.consultarReclamantesFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.consultarReclamantesSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.consultarReclamantesFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al consultar reclamantes.",
      })
    );
  }
}

function* insertarCobertura({ payload }) {
  yield put(EgresosActions.insertarCoberturaLoading());

  try {
    const response = yield call(
      EgresosService.insertarCobertura,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.insertarCoberturaFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.insertarCoberturaFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.insertarCoberturaSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.insertarCoberturaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al insertar cobertura.",
      })
    );
  }
}

function* cerrarCuentaClinica({ payload }) {
  yield put(EgresosActions.cerrarCuentaClinicaLoading());

  try {
    const response = yield call(
      EgresosService.cerrarCuentaClinica,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.cerrarCuentaClinicaFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.cerrarCuentaClinicaFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.cerrarCuentaClinicaSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.cerrarCuentaClinicaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al cerrar cuenta clínica.",
      })
    );
  }
}

function* enviarReclamacion({ payload }) {
  yield put(EgresosActions.enviarReclamacionLoading());

  const { coberturasEnMemoria, payloadCerrarCuenta } = payload;

  try {
    // Paso 1: Insertar todas las coberturas en memoria en paralelo
    if (Array.isArray(coberturasEnMemoria) && coberturasEnMemoria.length > 0) {
      const insertResults = yield all(
        coberturasEnMemoria.map((cobertura) =>
          call(EgresosService.insertarCobertura, cobertura)
        )
      );

      // Verificar si alguna inserción falló
      for (let i = 0; i < insertResults.length; i++) {
        const result = insertResults[i];
        
        // Validar error del backend (respuesta.codigo)
        if (
          !result?.respuesta ||
          result.respuesta.codigo === ResponseCode.SERVER_ERROR.code
        ) {
          yield put(
            EgresosActions.enviarReclamacionFailure({
              codigo: ResponseCode.SERVER_ERROR.code,
              mensaje: `Error al insertar cobertura ${coberturasEnMemoria[i]?.cobertura}: ${ResponseCode.SERVER_ERROR.message}`,
              tipoError: "insercion",
            })
          );
          return;
        }

        if (!isOkCode(result.respuesta.codigo)) {
          yield put(
            EgresosActions.enviarReclamacionFailure({
              codigo: result.respuesta.codigo,
              mensaje: `Error al insertar cobertura ${coberturasEnMemoria[i]?.cobertura}: ${result.respuesta.mensaje}`,
              tipoError: "insercion",
            })
          );
          return;
        }

        // Validar error del servicio de inserción (satisfactorio === false)
        const satisfactorio = result?.data?.satisfactorio ?? result?.satisfactorio;
        if (satisfactorio === false) {
          const mensajeError = result?.data?.mensaje || result?.mensaje || "Error desconocido";
          yield put(
            EgresosActions.enviarReclamacionFailure({
              codigo: -1,
              mensaje: `Error al insertar cobertura ${coberturasEnMemoria[i]?.cobertura}: ${mensajeError}`,
              tipoError: "insercion",
            })
          );
          return;
        }
      }
    }

    // Paso 2: Cerrar la cuenta clínica
    const cerrarResponse = yield call(
      EgresosService.cerrarCuentaClinica,
      payloadCerrarCuenta
    );

    if (
      !cerrarResponse?.respuesta ||
      cerrarResponse.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.enviarReclamacionFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: "Error al cerrar la cuenta clínica: " + ResponseCode.SERVER_ERROR.message,
          tipoError: "cierreCuenta",
        })
      );
      return;
    }

    const codigoCerrar = cerrarResponse.respuesta.codigo;

    if (!isOkCode(codigoCerrar)) {
      yield put(
        EgresosActions.enviarReclamacionFailure({
          ...cerrarResponse.respuesta,
          mensaje: "Error al cerrar la cuenta clínica: " + (cerrarResponse.respuesta.mensaje || "Error desconocido"),
          tipoError: "cierreCuenta",
        })
      );
      return;
    }

    yield put(
      EgresosActions.enviarReclamacionSuccess({
        mensaje: "La cuenta clínica ha sido cerrada satisfactoriamente. A partir de este momento, los datos ingresados no podrán ser modificados desde WebSalud. Si necesita realizar un ajuste o corrección, por favor contacte a nuestro Centro de Atención al Cliente.",
        data: cerrarResponse.data,
      })
    );
  } catch (error) {
    yield put(
      EgresosActions.enviarReclamacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje:
          error?.message || "Error inesperado al enviar reclamación.",
        tipoError: "general",
      })
    );
  }
}

function* calcularOxigeno({ payload }) {
  yield put(EgresosActions.calcularOxigenoLoading());

  try {
    const response = yield call(
      EgresosService.calcularOxigeno,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.calcularOxigenoSuccess({
          success: false,
          message: ResponseCode.SERVER_ERROR.message
        })
      );
      return;
    }

    if (response?.respuesta?.codigo === -1) {
      yield put(
        EgresosActions.calcularOxigenoSuccess({
          success: false,
          message: response.respuesta.mensaje
        })
      );
      return;
    }

    yield put(
      EgresosActions.calcularOxigenoSuccess({
        ...response.data,
         success: true
      })
    );
  } catch (error) {
      yield put(
        EgresosActions.calcularOxigenoSuccess({
          success: false,
          message: ResponseCode.SERVER_ERROR.message
        })
      );
  }
}

export function* formConsultaCierresCuentas(request) {
  yield put(EgresosActions.formConsultaCierresCuentasLoading());

  yield put(EgresosActions.formConsultaCierresCuentasSuccess(request?.payload));
}

function* consultarCierresCuentas(request) {
  yield put(EgresosActions.consultarCierresCuentasLoading());

  try {
    const {
      formConsultaCierresCuentasData,
      formHandler,
      reclamante,
      fechaInicio,
      fechaFin,
      numeroReclamo,
      numeroCarnet,
      servicio,
      fechaServicioDesde,
      fechaServicioHasta,
      cedula,
      plan,
      pssHonorario,
      numeroPagina = 1,
      tamanoPagina = 10,
    } = request.payload;

    const requestCierres = {
      CodigoReclamante: reclamante,
      FechaSalidaInicial: fechaInicio,
      FechaSalidaFinal: fechaFin,
      Compania: 30,
      NumeroPagina: numeroPagina,
      TamanoPagina: tamanoPagina,
    };

    // Agregar filtros opcionales solo si tienen valor válido (no undefined, no vacío)
    if (numeroReclamo !== undefined && numeroReclamo !== null && numeroReclamo !== "") {
      const valor = String(numeroReclamo).trim();
      if (valor !== "") {
        requestCierres.Secuencial = Number(valor);
        // Cuando se envía No. Reclamo, enviar el año de Fecha Salida Desde
        if (fechaInicio) {
          requestCierres.Ano = new Date(fechaInicio).getFullYear();
        }
      }
    }
    
    if (numeroCarnet !== undefined && numeroCarnet !== null && numeroCarnet !== "") {
      const valor = String(numeroCarnet).trim();
      if (valor !== "") {
        requestCierres.NumeroPlastico = Number(valor);
      }
    }
    
    // El servicio ya viene como código numérico desde el formulario
    if (servicio !== undefined && servicio !== null && servicio !== "") {
      const valor = String(servicio).trim();
      if (valor !== "") {
        requestCierres.Servicio = Number(valor);
      }
    }
    
    if (fechaServicioDesde !== undefined && fechaServicioDesde !== null && fechaServicioDesde !== "") {
      const valor = fechaServicioDesde.trim();
      if (valor !== "") {
        requestCierres.FechaIngresoDesde = valor;
      }
    }
    
    if (fechaServicioHasta !== undefined && fechaServicioHasta !== null && fechaServicioHasta !== "") {
      const valor = fechaServicioHasta.trim();
      if (valor !== "") {
        requestCierres.FechaIngresoHasta = valor;
      }
    }
    
    if (cedula !== undefined && cedula !== null && cedula !== "") {
      const valor = String(cedula).trim();
      if (valor !== "") {
        requestCierres.Cedula = valor;
      }
    }
    
    if (plan !== undefined && plan !== null && plan !== "") {
      const valor = String(plan).trim();
      if (valor !== "") {
        requestCierres.Plan = Number(valor);
      }
    }
    
    if (pssHonorario !== undefined && pssHonorario !== null && pssHonorario !== "") {
      const valor = String(pssHonorario).trim();
      if (valor !== "" && Number(valor) !== 0) {
        requestCierres.PssHonorario = Number(valor);
      }
    }

    const response = yield call(
      EgresosService.consultarCierresCuentas,
      requestCierres
    );

    // Si data es null o codigo 204 (Datos no encontrados), limpiar el estado de Redux
    const sinDatos = response?.data == null || response?.respuesta?.codigo === 204;
    const emptyDataCierres = { cierreCuentas: [], cantidadRegistros: 0 };
    const dataCierres = sinDatos
      ? emptyDataCierres
      : (response?.data || emptyDataCierres);

    const mensajeSinRegistros =
      response?.respuesta?.mensaje || "No se encontraron registros para los criterios de búsqueda seleccionados.";
    const mostrarAlertaSinRegistros = sinDatos || !dataCierres?.cierreCuentas?.length;

    // Construir payload sin arrastrar dataCierres anterior: así Redux recibe lista vacía y se limpia el estado
    const { dataCierres: _omitDataCierres, ...restForm } = formConsultaCierresCuentasData;
    const successPayload = {
      ...restForm,
      dataCierres,
      fechaInicio,
      fechaFin,
      paginaActual: numeroPagina,
      tamanoPagina,
      ...(mostrarAlertaSinRegistros && {
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: mensajeSinRegistros,
          onConfirm: () => {
            const { dataCierres: _o, ...rest } = formConsultaCierresCuentasData;
            formHandler({
              ...rest,
              dataCierres: { cierreCuentas: [], cantidadRegistros: 0 },
              showAlert: false,
              alertConfig: undefined,
              fechaInicio,
              fechaFin,
              paginaActual: numeroPagina,
              tamanoPagina,
            });
          },
        },
        showAlert: true,
      }),
    };

    yield put(EgresosActions.formConsultaCierresCuentasSuccess(successPayload));
  } catch (error) {
    yield put(
      EgresosActions.formConsultaCierresCuentasSuccess({
        ...request.payload.formConsultaCierresCuentasData,
        alertConfig: {
          type: "error",
          title: "Error",
          message: error?.mensaje || "Error al consultar cierres de cuentas. Por favor, intente de nuevo.",
          onConfirm: () => {
            request.payload.formHandler({
              ...request.payload.formConsultaCierresCuentasData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
        dataCierres: null,
      })
    );
  }
}

function* consultarPlanesEgreso({ payload }) {
  yield put(EgresosActions.consultarPlanesEgresoLoading());

  try {
    const response = yield call(EgresosService.consultarPlanesEgreso, payload);

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.consultarPlanesEgresoFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    if (!isOkCode(response.respuesta?.codigo)) {
      yield put(
        EgresosActions.consultarPlanesEgresoFailure(response.respuesta || {})
      );
      return;
    }

    yield put(
      EgresosActions.consultarPlanesEgresoSuccess(response.data || { planes: [] })
    );
  } catch (error) {
    yield put(
      EgresosActions.consultarPlanesEgresoFailure({
        codigo: error?.codigo ?? -1,
        mensaje: error?.mensaje || error?.message || "Error al consultar planes.",
      })
    );
  }
}

function* cambiarServicio({ payload }) {
  yield put(EgresosActions.cambiarServicioLoading());

  try {
    const response = yield call(
      EgresosService.cambiarServicio,
      payload
    );

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.cambiarServicioFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.cambiarServicioFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.cambiarServicioSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.cambiarServicioFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error inesperado al cambiar el servicio.",
      })
    );
  }
}

function* consultarEstatusHojaQuirurgica({ payload }) {
  yield put(EgresosActions.consultarEstatusHojaQuirurgicaLoading());

  try {
    const response = yield call(EgresosService.consultarEstatusHojaQuirurgica, payload);

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.consultarEstatusHojaQuirurgicaFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.consultarEstatusHojaQuirurgicaFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.consultarEstatusHojaQuirurgicaSuccess(response.data)
    );

    // Después de obtener el estatus, llamar al segundo endpoint para obtener el detalle de coberturas
    const estatusCoberturas = response.data?.estatusCoberturas || [];
    if (Array.isArray(estatusCoberturas) && estatusCoberturas.length > 0) {
      // Tomar el secuencial del primer registro
      const primerRegistro = estatusCoberturas[0];
      const secuencial = primerRegistro?.secuencial;

      // Validar que el secuencial sea válido: no null y > 0
      if (secuencial != null && secuencial !== undefined && Number(secuencial) > 0) {
        // Llamar al segundo endpoint para obtener el detalle de coberturas
        // Solo se llama una vez si el secuencial es válido
        yield put(
          EgresosActions.consultaIngresoDetalleCoberturaHojaQx({ secuencial: Number(secuencial) })
        );
      }
    }
  } catch (error) {
    yield put(
      EgresosActions.consultarEstatusHojaQuirurgicaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error inesperado al consultar estatus de hoja quirúrgica.",
      })
    );
  }
}

function* validarIngresoExistente({ payload }) {
  yield put(EgresosActions.validarIngresoExistenteLoading());

  try {
    const response = yield call(EgresosService.validarIngresoExistente, payload);

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.validarIngresoExistenteFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.validarIngresoExistenteFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.validarIngresoExistenteSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.validarIngresoExistenteFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error inesperado al validar ingreso existente.",
      })
    );
  }
}

function* consultaIngresoDetalleCoberturaHojaQx({ payload }) {
  yield put(EgresosActions.consultaIngresoDetalleCoberturaHojaQxLoading());

  try {
    const response = yield call(EgresosService.consultarDetalleCobertura, payload);

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.consultaIngresoDetalleCoberturaHojaQxFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.consultaIngresoDetalleCoberturaHojaQxFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.consultaIngresoDetalleCoberturaHojaQxSuccess(response.data)
    );
  } catch (error) {
    yield put(
      EgresosActions.consultaIngresoDetalleCoberturaHojaQxFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error inesperado al consultar detalle de cobertura.",
      })
    );
  }
}

function* consultarDiasHospitalarios() {
  yield put(EgresosActions.consultarDiasHospitalariosLoading());

  try {
    const response = yield call(EgresosService.consultarDiasHospitalarios);

    if (
      !response?.respuesta ||
      response.respuesta.codigo === ResponseCode.SERVER_ERROR.code
    ) {
      yield put(
        EgresosActions.consultarDiasHospitalariosFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: ResponseCode.SERVER_ERROR.message,
        })
      );
      return;
    }

    const codigo = response.respuesta.codigo;

    if (!isOkCode(codigo)) {
      yield put(
        EgresosActions.consultarDiasHospitalariosFailure(response.respuesta)
      );
      return;
    }

    yield put(
      EgresosActions.consultarDiasHospitalariosSuccess(response.data || {})
    );
  } catch (error) {
    yield put(
      EgresosActions.consultarDiasHospitalariosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error inesperado al consultar días hospitalarios.",
      })
    );
  }
}

const exportedArray = [
  takeLatest(EgresosTypes.CONSULTAR_INGRESOS_PSS, consultarIngresosPss),
  takeLatest(
    EgresosTypes.CONSULTAR_COBERTURAS_CIERRE_CUENTA,
    consultarCoberturasCierreCuenta
  ),
  takeLatest(EgresosTypes.ELIMINAR_COBERTURA, eliminarCobertura),
  takeLatest(EgresosTypes.BUSCAR_CUENTAS_CERRADAS, buscarCuentasCerradas),
  takeLatest(EgresosTypes.VALIDAR_COBERTURA, validarCobertura),
  takeLatest(EgresosTypes.VALIDAR_SERVICIO_AMBULATORIO, validarServicioAmbulatorio),
  takeLatest(EgresosTypes.CONSULTAR_TIPO_PSS_NO_MEDICO_EGRESO, consultarTipoPssNoMedico),
  takeLatest(EgresosTypes.VALIDAR_AFILIADO_VIGENTE, validarAfiliadoVigente),
  takeLatest(EgresosTypes.GUARDAR_EGRESO, guardarEgreso),
  takeLatest(EgresosTypes.CONSULTAR_RECLAMANTES, consultarReclamantes),
  takeLatest(EgresosTypes.CALCULAR_OXIGENO, calcularOxigeno),
  takeLatest(EgresosTypes.INSERTAR_COBERTURA, insertarCobertura),
  takeLatest(EgresosTypes.CERRAR_CUENTA_CLINICA, cerrarCuentaClinica),
  takeLatest(EgresosTypes.VALIDAR_INGRESO_EXISTENTE, validarIngresoExistente),
  takeLatest(EgresosTypes.ENVIAR_RECLAMACION, enviarReclamacion),
  takeLatest(EgresosTypes.FORM_CONSULTA_CIERRES_CUENTAS, formConsultaCierresCuentas),
  takeLatest(EgresosTypes.CONSULTAR_CIERRES_CUENTAS, consultarCierresCuentas),
  takeLatest(EgresosTypes.CONSULTAR_PLANES_EGRESO, consultarPlanesEgreso),
  takeLatest(EgresosTypes.CAMBIAR_SERVICIO, cambiarServicio),
  takeLatest(EgresosTypes.CONSULTAR_ESTATUS_HOJA_QUIRURGICA, consultarEstatusHojaQuirurgica),
  takeLatest(EgresosTypes.CONSULTA_INGRESO_DETALLE_COBERTURA_HOJA_QX, consultaIngresoDetalleCoberturaHojaQx),
  takeLatest(EgresosTypes.CONSULTAR_DIAS_HOSPITALARIOS, consultarDiasHospitalarios),
];

export default exportedArray;
